import { fetchCachedHelper } from './api'

//Using the search api because the current top selling API's don't return the extra info I need.
export const fetchTopSellingCourses = async () => {
    const response = await fetchCachedHelper(
        `Search/GetCourses?Sort=enrolled&pageSize=10`
    )
    return response.data.data
}

export const fetchTopSellingClasses = async () => {
    const response = await fetchCachedHelper(
        `Search/GetClasses?Sort=enrolled&pageSize=10`
    )
    return response.data.data
}
